import { MouseEventHandler } from "react"
import { Checkbox as AntCheckbox } from "antd"
import { CheckboxProvier } from "components/providers/Checkbox.provider"
import type { CheckboxChangeEvent } from "antd/es/checkbox"

type Props = {
	defaultChecked?: boolean
	onChange: (e: CheckboxChangeEvent) => void
	onClick?: MouseEventHandler<HTMLElement>
	checked?: boolean
	disabled?: boolean
}

export const Checkbox = ({ defaultChecked, onChange, checked, onClick, disabled }: Props) => {
	return (
		<CheckboxProvier>
			<AntCheckbox defaultChecked={defaultChecked} checked={checked} onClick={onClick} onChange={onChange} disabled={disabled} />
		</CheckboxProvier>
	)
}
